import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './send-money-form.scss'
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";
import { sendMoneyTransaction, getConversionRate } from '../../../services/transaction-service';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { DynamicTableCell } from "../../../contexts/TableContext";

const COUNTRY_OPTIONS = [
  { value: "XAF", label: "Cameroon" },
  { value: "RWF", label: "Rwanda" },
  { value: "KES", label: "Kenya" },
  { value: "UGX", label: "Uganda" },
];

const validationSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([0-9]){5}/,
      'PIN should be numeric. No special characters allowed'
    ),
  senderPhone: Yup.number()
    .required('Phone number must be valid and contain only numbers including country code and no special caracters.')
    .min(7),
  momoDepositNumber: Yup.number()
    .required('Phone number must be valid and contain only numbers including country code and no special caracters.')
    .min(7),
  momoDepositName: Yup.string()
    .required('This field is missing'),
  reason: Yup.string()
    .required('This field is missing'),
  from: Yup.string()
    .required('This field is missing'),
  to: Yup.string()
    .required('This field is missing'),
  amount: Yup.number()
    .required('Only number allowed here')
});

const SendMoneyForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formReady, setFormReady] = useState(false);
  const [amountLoader, setAmountLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [rate, setRate] = useState("");
  const [fromCurrency, setFromCurrency] = useState("XAF");
  const [toCurrency, setToCurrency] = useState("RWF");
  const [paymentList, setPaymentList] = useState([]);
  const [amount, setAmount] = useState(0);
  const [amountToSend, setAmountToSend] = useState(0);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    // console.log(`Submitting the following data ${JSON.stringify(values)}`);
    sendMoneyTransaction(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setPaymentList(res.data.codes);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  const formatAmount = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  const getSendAmount = (amountValue) => {
    setAmount(amountValue);
    setAmountLoader(true);
    setTimeout( () => 
      getConversionRate(amountValue, fromCurrency, toCurrency).then(res => {
        if(res.status_code == 200 || res.status_code == 201) {
          // console.log('data', res.data);
          setRate(res.data?.rate);
          setAmountToSend(formatAmount(res.data?.result) + ` ${toCurrency}`);
          setAmount(amountValue);
          setMessage(res.data.message);
          setFormReady(true);
        }else {
          toast(`Sorry! ${res.message}`);
          setErrorMessage(res.message);
        }
      }).catch(err => {
        toast(`Sorry, ${err.message}`, {
          toastId: 12
        })
        setErrorMessage(err.message);
        setFormReady(false);
      }).finally( _ => setAmountLoader(false)),
      1500
    );
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          senderPhone: "",
          momoDepositNumber: "",
          momoDepositName: "",
          id: userId,
          reason: "",
          from: "XAF",
          to: "RWF",
          amount: amount
        }}
        onSubmit={(values) => {
          values.amount = amount;
          values.from = fromCurrency;
          values.to = toCurrency;
          handleSubmit(values);
        }}
        validationSchema={validationSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Fill the form to send your money.</p>
            </div>
            <div className={`field`}>
              <label htmlFor="from">From</label>
              <select 
                name={`from`}
                id={`from`} 
                value={fromCurrency} 
                onChange={event => setFromCurrency(event.target.value)} 
                className="__form-input">
                  {COUNTRY_OPTIONS.map((country) => (
                    <option key={country.value} value={country.value}>
                      {country.label}
                    </option>
                  ))}
              </select>
              {errors.country && touched.country ? (
                <div className="error">{errors.country}</div>
                ) : null
              }
            </div>
            <div className={`field`}>
              <label htmlFor="to">To</label>
              <select 
                name={`to`}
                id={`to`} 
                value={toCurrency} 
                onChange={event => setToCurrency(event.target.value)} 
                className="__form-input">
                  {COUNTRY_OPTIONS.map((country) => (
                    <option key={country.value} value={country.value}>
                      {country.label}
                    </option>
                  ))}
              </select>
              {errors.country && touched.country ? (
                <div className="error">{errors.country}</div>
                ) : null
              }
            </div>
            <div className={`field`}>
              <label htmlFor="momoDepositNumber">Receiver Number*</label>
              <input
                name="momoDepositNumber"
                id="momoDepositNumber"
                placeholder="A momo/om/airtel/m-pesa number with country code"
                value={values.momoDepositNumber}
                onChange={handleChange} />
              {errors.momoDepositNumber && touched.momoDepositNumber ? (
                <div className="error">{errors.momoDepositNumber}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="momoDepositName">Receiver Name*</label>
              <input
                name="momoDepositName"
                id="momoDepositName"
                placeholder="Receiver name and number"
                value={values.momoDepositName}
                onChange={handleChange} />
              {errors.momoDepositName && touched.momoDepositName ? (
                <div className="error">{errors.momoDepositName}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="reason">Reason*</label>
              <input
                name="reason"
                id="reason"
                placeholder="What is this for?"
                value={values.reason}
                onChange={handleChange} />
              {errors.reason && touched.reason ? (
                <div className="error">{errors.reason}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="amount">Amount to send ({fromCurrency})</label>
              <input
                name="amount"
                id="amount"
                type='number'
                min={100}
                step={1}
                placeholder="Amount"
                value={amount}
                onChange={event => getSendAmount(event.target.value)}
              />
              {errors.amount && touched.amount ? (
                <div className="error">{errors.amount}</div>
              ) : null}
              <BeatLoader
                color={Constant.spinner_color}
                loading={amountLoader}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {formReady && <h2 className="login-success" style={{"fontWeight" : 900, "fontSize" : '25px', "color": 'red'}}>Receive: { amountToSend }</h2>}
              {formReady && <h6 className="login-success" style={{"fontWeight" : 700, "fontSize" : '12px',  "color": 'green'}}>Rate: { rate }</h6>}
            </div>
            <div className={`field`}>
              <label htmlFor="senderPhone">Sender number</label>
              <input
                name="senderPhone"
                id="senderPhone"
                placeholder="Enter Your momo/om/airtel/m-pesa etc, to debit"
                value={values.senderPhone}
                onChange={handleChange}
              />
              {errors.senderPhone && touched.senderPhone ? (
                <div className="error">{errors.senderPhone}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                name="pin"
                id="pin"
                type='password'
                placeholder="Your PIN"
                value={values.pin}
                maxLength={5}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            {!isLoading && 
            <button type="submit" disabled={isLoading}>
              <span>Continue</span>
            </button>
            }
            <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && message != '' &&
        <>
          
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer
              sx={{ maxHeight: 500 }}
              style={{ boxShadow: "none" }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                      <TableCell
                        key={100}
                      >
                        {message}
                      </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentList
                    .map((code, index) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                          <DynamicTableCell>
                            <TableCell align="left">{code}</TableCell>
                          </DynamicTableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </>
      }
    </div>
  );
};

export default SendMoneyForm;
